/**
 * Session-related constants shared between web (idle reload) and backend (analytics cleanup).
 * Same 1h threshold: reload app after idle on home, and clean analytics sessions that never went past "session_started".
 */

/** Delay in ms before reloading the app when idle on home (1 hour). Also used as threshold for cleaning stale analytics sessions. */
export const HOME_IDLE_RELOAD_MS = 60 * 60 * 1000;
